import { render, staticRenderFns } from "./horizontal.vue?vue&type=template&id=d7fabfd4&"
import script from "./horizontal.vue?vue&type=script&lang=js&"
export * from "./horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports